import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    dateRangeBookability: builder.query({
      query: (args) =>
        generateURL('/availability/date_range_bookability', {
          resource_ids: args.resourceIds,
          passenger_type_numbers: args.passengerTypeNumbers,
          date_from: args.fromDate,
          date_to: args.toDate,
        }),
      providesTags: ['availability'],
      keepUnusedDataFor: 3600,
    }),
    tickets: builder.query({
      query: (args) =>
        generateURL('/availability/tickets', {
          date: args.date,
          product_type_id: args.productTypeId,
          resource_category_id: args.resourceCategoryId,
          logged_in: args.loggedIn,
        }),
      providesTags: ['availability'],
      keepUnusedDataFor: 3600,
    }),
    bulk: builder.query({
      query: (args) =>
        generateURL('/availability/bulk', {
          resource_ids: args.resourceIds,
          units: args.units,
          date_from: args.fromDate,
          date_to: args.toDate,
        }),
      providesTags: ['availability'],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useDateRangeBookabilityQuery, useTicketsQuery, useBulkQuery } =
  apiSlice;
